import React from 'react';
import { useLocalStorage, LS_KEYS } from '../hooks/useLocalStorage';
import { useJwt } from '../hooks/useJwt';
import useApi from './useApi';

export const useAuth = () => {
  const { post } = useApi(LS_KEYS.BACKOFFICE);
  const { post: postSite } = useApi(LS_KEYS.SITE);

  const { getLSItem: getLSItemBackoffice } = useLocalStorage(
    LS_KEYS.BACKOFFICE,
  );
  const { getJwtPayload } = useJwt();

  /**
   * Backoffice login
   */
  const login = React.useCallback(
    async (username, password) => {
      const data = await post('/login', { username, password });
      const { token } = data;
      const {
        name,
        userId,
        access: { items: access },
      } = getJwtPayload(token);

      return {
        token,
        userId,
        username: name,
        access,
      };
    },
    [getJwtPayload, post],
  );

  /**
   * Site login with native register
   */
  const siteLogin = React.useCallback(
    async (email, password) => {
      const siteLoginResponse = await postSite('/login/site', {
        email,
        password,
      });

      const { token } = siteLoginResponse;
      const { name } = getJwtPayload(token);
      return { token, name, email };
    },
    [getJwtPayload, postSite],
  );

  /**
   * Site login with facebook
   */
  const facebookLogin = React.useCallback(
    async (email, accessToken) => {
      const facebookLoginResponse = await postSite('/login/facebook', {
        email,
        accessToken,
      });

      const { token } = facebookLoginResponse;
      const { name } = getJwtPayload(token);
      return { token, name, email };
    },
    [getJwtPayload, postSite],
  );

  const logout = React.useCallback(() => {
    // TODO verificar se será necessário
  }, []);

  const isLogged = !!getLSItemBackoffice('auth');

  return { login, logout, isLogged, facebookLogin, siteLogin };
};

export default useAuth;
